import {useEffect, useState} from 'react'
import {useSpotHelperGetCurrent} from './entity/useSpot'

type Size = {
  readonly width: number
  readonly height: number
}

export function useBrowserTitle(title: string | undefined): void {
  const {spot} = useSpotHelperGetCurrent()

  useEffect(() => {
    const parts = ['VerticalTopo']
    if (spot) {
      parts.push(spot.name)
    }
    if (title) {
      parts.push(title)
    }
    document.title = parts.join(' - ')
  }, [spot, title])
}

export function useViewportSize(): Size {
  const [height, setHeight] = useState<number>(window.innerHeight)
  const [width, setWidth] = useState<number>(window.innerWidth)

  useEffect(() => {
    const handler = () => {
      setHeight(window.innerHeight)
      setWidth(window.innerWidth)
    }
    const controller = new AbortController()
    window.addEventListener('resize', handler, {signal: controller.signal})
    handler()

    return () => {
      controller.abort()
    }
  }, [])

  return {
    width,
    height,
  }
}
